// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__17LwW","consentsList":"PatientConsents_consentsList__1B_wN","consentsListEmpty":"PatientConsents_consentsListEmpty__1ncMw"};